import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 根据钉钉用户ID获取店员信息
 */
export const getClerkByDdUserId = () => {
  return axios.request({
    url: '/s/c/clerk/getByDdUserId',
    params: {
    },
    method: 'get'
  })
}

/**
 * 添加店员
 */
export const addClerk = (name, sex) => {
  let data = new URLSearchParams()
  data.append("name", name)
  data.append("sex", sex)
  return axios.request({
    url: '/s/c/clerk/add',
    data,
    method: 'post'
  })
}


/**
 * 获取我的资料
 */
export const getClerk = () => {
  return axios.request({
    url: '/s/c/clerk/get',
    params: {
    },
    method: 'get'
  })
}

/**
 * 获取我的资料-电竞
 */
export const getGamingClerkInfo = () => {
  return axios.request({
    url: '/s/c/clerk/getGamingClerkInfo',
    params: {
    },
    method: 'get'
  })
}

// 获取店员工资明细
export const getStatisticsInfo = () => {
  return axios.request({
    url: '/s/c/wages/getStatisticsInfo',
    method: 'get'
  })
}


/**
 * 修改状态
 */
export const updateClerkStatus = (status,updateAutoOnline=false) => {
  return axios.request({
    url: '/s/c/clerk/updateStatus',
    params: {
      status,
      updateAutoOnline
    },
    method: 'post'
  })
}

/**
 * 修改服务类型
 */
export const updateItemType = (itemType, categoryIds) => {
  let data = new URLSearchParams()
  data.append('itemType',itemType)
  data.append('categoryIds',categoryIds)
  return axios.request({
    url: '/s/c/clerk/updateItemType',
    data,
    method: 'post'
  })
}
/**
 * 修改随机单接单开关
 */
export const updateRandomOrderSwitch = (randomOrderSwitch) => {
  let data = new URLSearchParams()
  data.append("randomOrderSwitch", randomOrderSwitch)
  return axios.request({
    url: '/s/c/clerk/updateRandomOrderSwitch',
    data,
    method: 'post'
  })
}

/**
 * 修改星座
 */
export const updateConstellation = (constellation) => {
  return axios.request({
    url: '/s/c/clerk/updateConstellation',
    params: {
      constellation
    },
    method: 'post'
  })
}

/**
 * 修改声音
 */
export const updateSound = (sound) => {
  let data = new URLSearchParams()
  data.append('sound',sound)
  return axios.request({
    url: '/s/c/clerk/updateSound',
    data,
    method: 'post'
  })
}

/**
 * 修改名称
 */
export const updateName = (name) => {
  return axios.request({
    url: '/s/c/clerk/updateName',
    params: {
      name
    },
    method: 'post'
  })
}

/**
 * 修改性别
 */
export const updateSex = (sex) => {
  return axios.request({
    url: '/s/c/clerk/updateSex',
    params: {
      sex
    },
    method: 'post'
  })
}

/**
 * 修改年龄
 */
export const updateAge = (age) => {
  return axios.request({
    url: '/s/c/clerk/updateAge',
    params: {
      age
    },
    method: 'post'
  })
}

/**
 * 修改个性签名
 */
export const updateSignature = (signature, itemType) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,"signature", signature)
  appendIfNotEmpty(data,"itemType", itemType)
  return axios.request({
    url: '/s/c/clerk/updateSignature',
    data,
    method: 'post'
  })
}

/**
 * 修改擅长领域
 */
export const updateAreasExpertise = (areasExpertise) => {
  let data = new URLSearchParams()
  data.append("areasExpertise", areasExpertise)
  return axios.request({
    url: '/s/c/clerk/updateAreasExpertise',
    data,
    method: 'post'
  })
}

/**
 * 修改咨询风格
 */
export const updateConsultStyle = (consultStyle) => {
  let data = new URLSearchParams()
  data.append("consultStyle", consultStyle)
  return axios.request({
    url: '/s/c/clerk/updateConsultStyle',
    data,
    method: 'post'
  })
}

/**
 * 修改头像
 */
export const updateAvatar = (avatar) => {
  let data = new URLSearchParams()
  data.append("avatar", avatar)
  return axios.request({
    url: '/s/c/clerk/updateAvatar',
    data,
    method: 'post'
  })
}

/**
 * 修改收款码
 */
export const updatePaymentCode = (codeType,qrcode) => {
  let data = new URLSearchParams()
  data.append("codeType",codeType)
  data.append("qrcode", qrcode)
  return axios.request({
    url: '/s/c/clerk/updatePaymentCode',
    data,
    method: 'post'
  })
}

/**
 * 修改威胁你
 * */
export const updateWechat = (wechat) => {
  let data = new URLSearchParams()
  data.append("wechat", wechat)
  return axios.request({
    url: '/s/c/clerk/updateWechat',
    data,
    method: 'post'
  })
}

/**
 * 修改微信二维码
 */
export const updateWechatCode = (qrcode) => {
  let data = new URLSearchParams()
  data.append("qrcode", qrcode)
  return axios.request({
    url: '/s/c/clerk/updateWechatCode',
    data,
    method: 'post'
  })
}

/**
 * 修改相册
 */
export const updatePhotos = (photos, itemType) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,"photos", photos)
  appendIfNotEmpty(data,"itemType", itemType)
  return axios.request({
    url: '/s/c/clerk/updatePhotos',
    data,
    method: 'post'
  })
}

/**
 * 修改音频
 */
export const updateAudio = (audio,itemType) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,"audio", audio)
  appendIfNotEmpty(data,"itemType", itemType)
  return axios.request({
    url: '/s/c/clerk/updateAudio',
    data,
    method: 'post'
  })
}

/**
 * 修改地区
 */
export const updateRegion = (regionNames, regionCodes) => {
  let data = new URLSearchParams()
  data.append("regionNames", regionNames)
  data.append("regionCodes", regionCodes)
  return axios.request({
    url: '/s/c/clerk/updateRegion',
    data,
    method: 'post'
  })
}

/**
 * 获取店员所属服务分类标签
 */
export const listItemTag = ()=>{
  return axios.request({
    url: '/s/c/clerk/listItemTag',
    method: 'get'
  })
}

/**
 * 修改标签
 */
export const updateTags = (tags, itemType) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,"tags", tags)
  appendIfNotEmpty(data,"itemType", itemType)
  return axios.request({
    url: '/s/c/clerk/updateTags',
    data,
    method: 'post'
  })
}

/**
 * 修改分类
 */
export const updateCategory = (categoryIds) => {
  let data = new URLSearchParams()
  data.append("categoryIds", categoryIds)
  return axios.request({
    url: '/s/c/clerk/updateCategory',
    data,
    method: 'post'
  })
}

/**
 * 获取服务开关
 */
export const getItemSwitchList = () => {
  return axios.request({
    url: '/s/c/clerk/getItemSwitchList',
    method: 'post'
  })
}


/**
 * 修改服务开关
 */
export const updateItemSwitch = (switchIds,switchId) => {
  let data = new URLSearchParams()
  data.append("switchIds", switchIds)
  data.append("switchId", switchId)
  return axios.request({
    url: '/s/c/clerk/updateItemSwitch',
    data,
    method: 'post'
  })
}

/**
 * 加载店员自动在线设置
 */
export  const loadClerkAutoOnlineSetting = () => {
  return axios.request({
    url: '/s/c/clerk/setting/autoOnline/get',
    method: 'get'
  })
}
export const updateClerkAutoOnlineStatus = (isAutoOnline)=>{
  let data = new URLSearchParams()
  data.append("isAutoOnline",isAutoOnline);
  return axios.request({
    url: '/s/c/clerk/setting/autoOnline/update',
    data,
    method: 'post'
  })
}
/**
 * 保存店员自动在线设置
 */
export const saveClerkAutoOnlineSetting = (isAutoOnline,autoOnlineOptions) => {
  let data = new URLSearchParams()
  data.append("isAutoOnline",isAutoOnline);
  data.append("onlineOptions",JSON.stringify(autoOnlineOptions))
  return axios.request({
    url: '/s/c/clerk/setting/autoOnline/save',
    data,
    method: 'post'
  })
}


//实名认证
export const nameVerify = (name,idCardNumber) => {
  let data = new URLSearchParams()
  data.append("name", name)
  data.append("idCardNumber",idCardNumber)

  return axios.request({
    url: '/s/c/clerk/idCardVerify',
    data,
    method: 'post'
  })
}
export const getDetectAuthUrl = (name,idCardNumber,redirectUrl)=>{
  return axios.request({
    url: '/s/c/clerk/getDetectAuthUrl',
    params:{
      name,
      idCardNumber,
      redirectUrl
    },
    method: 'post'
  })
}
export const getVerifyMethod = ()=> {
  return axios.request({
    url: '/s/c/clerk/getVerifyMethod',
    method: 'post'
  })
}
/**
 * 修改隐藏排名
 */
export const updateIsHideRanking = (isHideRanking)=>{
  return axios.request({
    url: '/s/c/clerk/updateIsHideRanking',
    params:{
      isHideRanking,
    },
    method: 'post'
  })
}
/**
 * 修改隐藏排名
 */
export const updateRecommendOn = (isRecommendOn)=>{
  return axios.request({
    url: '/s/c/clerk/updateRecommendOn',
    params:{
      isRecommendOn,
    },
    method: 'post'
  })
}

/**
 * 获取音卡
 */
export const getSoundCard = ()=>{
    return axios.request({
        url: '/s/c/clerk/getSoundCard',
        method: 'get'
    })
}

/**
 * 保存音卡
 */
export const saveSoundCard = (soundCardUrl)=>{
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'soundCardUrl',soundCardUrl)
    return axios.request({
        url: '/s/c/clerk/saveSoundCard',
        data,
        method: 'post'
    })
}
/**
 * 店员公众号推广URL
 */
export const wxgzhUrl = ()=>{
    return axios.request({
        url: '/s/c/clerk/wxgzhUrl',
        method: 'post'
    })
}
